webpackJsonp([50739212244294],{

/***/ 272:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(25);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _typography = __webpack_require__(17);
	
	var _Seo = __webpack_require__(38);
	
	var _Seo2 = _interopRequireDefault(_Seo);
	
	var _Nav = __webpack_require__(37);
	
	var _Nav2 = _interopRequireDefault(_Nav);
	
	var _gatsbyLink = __webpack_require__(33);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//This renders individual tags page e.g. http://localhost:8000/tags/tag-a/
	var Tags = function Tags(_ref) {
	  var pathContext = _ref.pathContext,
	      data = _ref.data;
	
	  var moment = __webpack_require__(35);
	  var now = moment(new Date());
	  var tag = pathContext.tag;
	  var _data$allMarkdownRema = data.allMarkdownRemark,
	      edges = _data$allMarkdownRema.edges,
	      totalCount = _data$allMarkdownRema.totalCount;
	
	  var tagHeader = totalCount + ' post' + (totalCount === 1 ? '' : 's') + ' tagged with "' + tag + '"';
	  var config = __webpack_require__(12);
	  //const facebook = (((data || {}).site || {}).siteMetadata || {}).facebook
	  var d = {
	    title: 'All posts tagged ' + tag + ' at ' + config.shortSiteTitle,
	    description: 'All posts tagged ' + tag + ' at ' + config.shortSiteTitle,
	    image: config.siteImage,
	    url: config.siteUrl + '/tags/' + tag,
	    keywords: config.resumeKeywords,
	    datePublished: "2018-07-01",
	    dateUpdated: now.format("YYYY-MM-DD")
	  };
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_Seo2.default, { data: d, pageType: 'taglist' }),
	    _react2.default.createElement(_Nav2.default, null),
	    _react2.default.createElement(
	      'p',
	      { style: {
	          marginBottom: '0px'
	        } },
	      tagHeader
	    ),
	    _react2.default.createElement(
	      'ul',
	      { style: {
	          marginLeft: '0px'
	        } },
	      edges.map(function (_ref2) {
	        var node = _ref2.node;
	        var title = node.frontmatter.title;
	
	        var tags = node.frontmatter.tags || [];
	        return _react2.default.createElement(
	          'div',
	          { key: node.fields.slug, style: {
	              // border: 'solid 1px red',
	              // borderRadius: '50',
	              // paddingLeft: rhythm(0.5),
	              // margin: rhythm(0.5),
	            } },
	          _react2.default.createElement(
	            'h3',
	            {
	              style: {
	                marginBottom: (0, _typography.rhythm)(1 / 4)
	              }
	            },
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { style: { boxShadow: 'none' }, to: node.fields.slug },
	              title
	            )
	          ),
	          tags.map(function (tag, index) {
	            return _react2.default.createElement(
	              'span',
	              {
	                style: {
	                  margin: '0px 12px 0px 0px',
	                  paddingLeft: '4px'
	                  //border: '1px solid rebeccapurple',
	                },
	                key: index,
	                className: 'tag'
	              },
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                {
	                  to: '/tags/' + tag,
	                  style: {
	                    color: 'rebeccapurple',
	                    textDecoration: 'none'
	                  }
	                },
	                tag
	              ),
	              ' '
	            );
	          }),
	          _react2.default.createElement(
	            'small',
	            null,
	            node.frontmatter.date
	          ),
	          _react2.default.createElement('p', { dangerouslySetInnerHTML: { __html: node.excerpt } })
	        );
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: {
	          display: 'flex',
	          justifyContent: 'space-between'
	        } },
	      _react2.default.createElement(
	        'h3',
	        null,
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { style: { boxShadow: 'none' }, to: '/tags' },
	          'All tags'
	        )
	      ),
	      _react2.default.createElement(
	        'h3',
	        null,
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { style: { boxShadow: 'none' }, to: '/blog' },
	          'All posts'
	        )
	      )
	    )
	  );
	};
	
	Tags.propTypes = {
	  pathContext: _propTypes2.default.shape({
	    tag: _propTypes2.default.string.isRequired
	  }),
	  data: _propTypes2.default.shape({
	    allMarkdownRemark: _propTypes2.default.shape({
	      totalCount: _propTypes2.default.number.isRequired,
	      edges: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	        node: _propTypes2.default.shape({
	          frontmatter: _propTypes2.default.shape({
	            //path: PropTypes.string.isRequired,
	            title: _propTypes2.default.string.isRequired
	          })
	        })
	      }).isRequired)
	    })
	  })
	};
	
	exports.default = Tags;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-tags-js-a92268140cf95a5b619d.js